// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"58636fd5","497":"9c659a26","578":"9f7839bc","641":"cf2c2b53","705":"f244f066","778":"e4c71db0","884":"0f168591"}[chunkId] + ".chunk.js";
};